var _defs, _path, _polygon, _path2, _polygon2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 501.34 184.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "RunningBeanCoSixBands") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.44,133.29a63.83,63.83,0,0,1-3.58,21.09h64.91L447.2,124.2H367.8A65.05,65.05,0,0,1,368.44,133.29Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "374.46 30.44 357.04 60.63 483.91 60.63 501.33 30.44 374.46 30.44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344.12,85.46A63.69,63.69,0,0,1,361.68,107h95.46L474.57,76.8H349.11Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "126.44 154.38 143.86 124.2 54.14 124.2 71.56 154.38 126.44 154.38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.46,51.55A63.9,63.9,0,0,1,136,30.44H0L17.43,60.63H133.09A65,65,0,0,1,132.46,51.55Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.78,104.27A63.62,63.62,0,0,1,136.61,76.8H26.77L44.2,107h111Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.21,87.11,356.06,30.2H321.21L291.45,81.74,274,111.92H300.3a21.36,21.36,0,1,1,0,42.72H231.94L321.23,0H200.59a51.54,51.54,0,0,0-22.9,97.71l-32.86,56.92h34.85l29.77-51.54L226.87,72.9H200.59a21.36,21.36,0,1,1,0-42.72h68.35L179.66,184.82H300.3a51.54,51.54,0,0,0,22.91-97.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6dead1a722946cb32e493f6390043e15.svg";
export { ForwardRef as ReactComponent };